import React, { memo, forwardRef } from "react";
const SvgForwardreaction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.707 10.293a1 1 0 10-1.414 1.414L24.586 15H5a1 1 0 100 2h19.586l-3.293 3.293a1 1 0 001.414 1.414l5-5a1 1 0 000-1.414l-5-5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgForwardreaction.displayName = "SvgForwardreaction";
const MemoForwardRef = memo(SvgForwardreaction);
export default MemoForwardRef;
